import type {
  ClusterRead,
  EntityRead,
  MembershipWithEntities,
} from "src/client";

export type ThemeChoice = "light" | "dark" | "system";

export interface ThemeSettings {
  themeMode: "light" | "dark";
  themeColor: "light" | "dark";
  themeDirection: string;
  view: string | null;
  userSelectedTheme?: boolean;
}

export function getInitials(
  firstName?: string | null,
  lastName?: string | null
): string {
  if (firstName && lastName)
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  if (firstName) return firstName.slice(0, 2).toUpperCase();
  if (lastName) return lastName.slice(0, 2).toUpperCase();
  return "?";
}

export function deriveThemeChoice(settings: ThemeSettings): ThemeChoice {
  if (!settings?.userSelectedTheme) return "system";
  return settings.themeMode;
}

export function getSystemThemePreference(): "light" | "dark" {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function getMembershipLabel(membership: MembershipWithEntities): string {
  if (membership.entity?.name) {
    return `${membership.entity.name} · ${membership.entity.clusterName || ""}`;
  }
  return membership.cluster?.name || "";
}

export function getMembershipPath(membership: MembershipWithEntities): string {
  if (membership.entity?.id) return `/entities/${membership.entity.id}/`;
  return `/clusters/${membership.cluster?.id}/`;
}

export function isEntityMembership(
  membership: MembershipWithEntities
): boolean {
  return !!membership.entity?.id;
}

export function filterOtherMemberships(
  memberships: MembershipWithEntities[],
  currentEntity?: EntityRead,
  currentCluster?: ClusterRead
): MembershipWithEntities[] {
  return memberships.filter((m) => {
    if (m.entity?.id) return m.entity.id !== currentEntity?.id;
    return m.cluster?.id !== currentCluster?.id;
  });
}
